module.exports = "<select class=\"form-control\" tabindex=\"{{tabIn}}\" multiple [compareWith]=\"compareFn\" [(ngModel)]=\"selectedItems\" (change)=\"onItemSelect()\">\r\n    <option *ngFor=\"let item of availableItems\" [disabled]=\"isDisabled(item)\" [value]=\"item\" [selected]=\"isSelected(item)\">{{item.displayName}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-controls/multi-select/multi-select.component.html
// module id = ./src/app/user-controls/multi-select/multi-select.component.html
// module chunks = main